/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const requestedDeliveryDate = {
  requestedDeliveryDate: {
    datePickerLabel: 'Solicitar data de entrega',
    readOnlyTextLabel: 'Data de entrega solicitada',
    successMessage: 'Data de entrega atualizada com sucesso.',
    errorMessage: 'Algo deu errado. A data solicitada não pode ser atualizada.',
  },
};
